// Circle.js
import React from "react";

const Circle = ({ radius, fill, stroke, strokeWidth }) => (
    <svg
        height={radius * 2}
        // width={radius * 2}
        // viewBox={`0 0 ${radius * 2} ${radius * 2}`}
        width={radius * 2 + 6} // Add 10px to the width for padding
        viewBox={`0 0 ${radius * 2 + 6} ${radius * 2}`}
    >
        <circle
            cx={radius}
            cy={radius}
            r={radius - strokeWidth / 2}
            fill={fill}
            stroke={stroke}
            strokeWidth={strokeWidth}
        />
    </svg>
);

export default Circle;
